
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class GroupService extends ApiEvsService {
    constructor(http: Http, router: Router) {
        super(http, router);
    }

    list(query?: any) {
        return this.get('/groups',query);
    }

    create(body: any) {
        return this.post('/group',body);
    }

    find(id) {
        return this.get('/group/'+id);
    }

    update(body) {
        return this.put('/updateGroup', body);
    }

    _delete(id) {
        return this.delete('/group/'+id);
    }

    allGroup(query?: any) {
        return this.get('/all-group', query);
    }
}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/common/services/Group.service.ts